<template>
  <div class="page-header"    :class="[isMobile?'banner-mobile':'banner-pc',className]" >
    <slot name="banner"></slot>
    <b-container fluid="xl" class="header-content">
      <NavBarPC v-if="!isMobile"/>
      <NavBarMobile v-else />

      <div class="header-style-1">
        <b-row>
          <b-col cols="12" md="10">
            <slot name="title"></slot>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="6">
            <slot name="detail"></slot>
          </b-col>
        </b-row>

        <slot name="image"></slot>
      </div>
    </b-container>
  </div>
</template>

<script>
import NavBarPC from './NavBar-pc'
import NavBarMobile from './NavBar-mobile'
import runtime from '../utils/runtime'

export default {
  name: 'HeaderStyles3',
  props: ['className'],
  components: {
    NavBarPC,
    NavBarMobile
  },
  data () {
    return {
      isMobile: runtime.isMobile()
    }
  }
}
</script>

<style lang="scss">
  .lang-selector {
    .popover-body {
      padding: 10px 0 !important;
    }
  }
</style>
<style scoped lang="scss">
  .page-header {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 774px;
    /*background: linear-gradient(165deg, #6c63ff 60%, #c77cf1);*/
    /*border-radius: 0px 0px 50px 0px;*/
    padding-top: 60px;
    overflow-x: hidden;

    .header-content {
      position: relative;
      flex: 1;
      overflow: hidden;
    }
  }

  .banner-pc{
    background: url(../assets/imgs/banner_img_project.jpg) no-repeat center;
  }

  .banner-mobile{
    background: url(../assets/imgs/banner_img_project_mobile.jpg) no-repeat center;
  }

  .header-style-1 {
    height: 100%;

    h1 {
      position: relative;
      z-index: 1;
      font-size: 50px;
      font-weight: 700;
      color: #ffffff;
      margin-top: 100px;
    }
    p {
      position: relative;
      z-index: 1;
      font-size: 16px;
      font-weight: 300;
      color: #ffffff;
      margin-top: 20px;
    }

    img {
      position: absolute;
      z-index: 0;
      right: 0;
      bottom: 0;
      max-width: 70%;
    }
  }

</style>
<style scoped lang="scss">
  @media (max-width: 768px) {
    .page-header {
      height: 400px;
      padding-top: 16px;
    }

    .header-style-1 {
      h1 {
        font-size: 18px;
        font-weight: 700;
        text-align: center;
        margin-top: 30px;
      }
      p {
        font-size: 10px;
        margin-top: 10px;
        width: 100%;
        text-align: center;
      }
      img {
        max-width: 60%;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
</style>
